module.exports = __webpack_public_path__ + "static/media/ursula-rucker.d38bb1af.md";